import React from 'react';

/**
 * GrammarErrorPopup — shown inline when hovering/clicking on a highlighted grammar error.
 * @param {object} error - { error_type, explanation_sq, example_correct, example_incorrect }
 * @param {function} onClose
 */
const RULE_EXPLANATIONS = {
  'V2_RULE':             { icon: '📐', title: 'V2-Rregulli', color: 'bg-red-50 border-red-200 text-red-900' },
  'VERB_POSITION':       { icon: '🔀', title: 'Pozicioni i Foljes', color: 'bg-orange-50 border-orange-200 text-orange-900' },
  'CONJUNCTION_VERB_END':{ icon: '🔗', title: 'Folja në Fund (Lidhëza)', color: 'bg-amber-50 border-amber-200 text-amber-900' },
  'SEPARABLE_VERB':      { icon: '✂️', title: 'Folje e Ndashme', color: 'bg-blue-50 border-blue-200 text-blue-900' },
  'CAPITALIZATION':      { icon: '🔤', title: 'Shkronja e Madhe', color: 'bg-amber-50 border-amber-200 text-amber-900' },
};

const GrammarErrorPopup = ({ error, onClose }) => {
  if (!error) return null;

  const meta = RULE_EXPLANATIONS[error.error_type] || {
    icon: '⚠️',
    title: error.error_type || 'Gabim Gramatike',
    color: 'bg-zinc-50 border-zinc-200 text-zinc-900',
  };

  return (
    <div className="fixed inset-0 z-[8000] flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/40 backdrop-blur-md" />
      <div
        className={`relative max-w-sm w-full rounded-2xl border p-5 shadow-[0_20px_50px_rgba(0,0,0,0.2)] backdrop-blur-2xl backdrop-saturate-150 animate-scaleIn ${meta.color}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-7 h-7 rounded-full bg-black/10 hover:bg-black/20 flex items-center justify-center text-sm transition-colors cursor-pointer"
        >
          ✕
        </button>

        <div className="flex items-center gap-3 mb-3">
          <span className="text-2xl">{meta.icon}</span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider opacity-60">{error.error_type}</p>
            <h3 className="font-bold text-base">{meta.title}</h3>
          </div>
        </div>

        {error.explanation_sq && (
          <p className="text-sm leading-relaxed mb-3">{error.explanation_sq}</p>
        )}

        {(error.example_incorrect || error.example_correct) && (
          <div className="space-y-1.5 text-sm">
            {error.example_incorrect && (
              <div className="flex items-start gap-2">
                <span className="text-red-500 font-bold shrink-0">✗</span>
                <span className="line-through opacity-70">{error.example_incorrect}</span>
              </div>
            )}
            {error.example_correct && (
              <div className="flex items-start gap-2">
                <span className="text-green-600 font-bold shrink-0">✓</span>
                <span className="font-medium">{error.example_correct}</span>
              </div>
            )}
          </div>
        )}

        <button
          onClick={onClose}
          className="mt-4 w-full py-2 rounded-lg bg-black/10 hover:bg-black/20 text-sm font-medium transition-colors cursor-pointer"
        >
          Kuptova — Mbyll
        </button>
      </div>
    </div>
  );
};

export default GrammarErrorPopup;
